export function partnerName(partners, id) {
  if (id === 0 || id === '0') return '总部'
  const hit = (partners || []).find(item => String(item.id) === String(id))
  return hit ? hit.name : (id == null || id === '' ? '—' : String(id))
}
